// IGNITE / YOURS nebula world. Implementation lives in ./nebula/world.js.
export { create } from './nebula/world.js';
